import { DrawerContext } from './DrawerContext'
import { useContext } from 'react'

/**
 * @returns {{
 *  isOpen: boolean,
 *  content: React.ReactNode,
 *  settings: {width?: number},
 *  openDrawer: (config: object) => void,
 *  updateDrawer: (config: object) => void,
 *  closeDrawer: () => void,
 *  toggleDrawer: (config: object) => void,
 *  id: string | null,
 * }}
 */
export const useDrawer = () => {
  const ctx = useContext(DrawerContext)
  if (!ctx) throw new Error('useDrawer must be used within DrawerProvider')
  return ctx
}
